import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedBrands from './components/FeaturedBrands';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '国产第一页',
            url: 'https://guochandiyiye.com/',
            description:
              '国产第一页，专注展示中国自主品牌的核心价值与竞争优势。汇聚国产精品，助力国货崛起，为消费者提供最权威的国产品牌导航与推荐。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://guochandiyiye.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '国产第一页',
            url: 'https://guochandiyiye.com/',
            description:
              '中国自主品牌权威导航与推荐平台',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-9999',
              contactType: 'customer service',
              email: 'contact@guochandiyiye.com',
            },
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressRegion: '北京市',
              addressCountry: 'CN',
              streetAddress: '朝阳区建国路88号',
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedBrands />
        <CategoryGrid />
        <LatestArticles />
        <StatsSection />
        <CTASection />
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
              常见问题
            </h2>
            <div className="space-y-4">
              {[
                {
                  q: '国产第一页是如何筛选品牌的？',
                  a: '我们由专业编辑团队根据品牌资质、产品质量、用户口碑、技术创新等维度进行综合评估，精选真正值得信赖的中国自主品牌。所有收录品牌均经过严格审核，确保信息真实可靠。',
                },
                {
                  q: '品牌如何申请入驻国产第一页？',
                  a: '品牌方可通过"关于我们"页面的联系方式提交入驻申请。我们将在收到申请后的5个工作日内进行审核评估，审核通过后将为品牌创建专属展示页面。',
                },
                {
                  q: '国产第一页的品牌信息多久更新一次？',
                  a: '我们的编辑团队会定期对平台收录的品牌信息进行更新维护。同时，已入驻品牌方也可随时联系我们来更新品牌信息，确保用户获取到最新、最准确的品牌资讯。',
                },
                {
                  q: '如何在国产第一页找到适合我的国货品牌？',
                  a: '您可以通过首页的分类导航浏览不同品类的品牌，也可以参考我们精选的推荐榜单和深度文章。每个品牌页面都包含详细的产品信息和用户评价，帮助您做出最佳选择。',
                },
              ].map((faq, idx) => (
                <details
                  key={idx}
                  className="bg-background-100 rounded-lg p-5 cursor-pointer group"
                >
                  <summary className="font-heading text-base font-semibold text-foreground-950 list-none flex items-center justify-between">
                    {faq.q}
                    <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: '国产第一页是如何筛选品牌的？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '我们由专业编辑团队根据品牌资质、产品质量、用户口碑、技术创新等维度进行综合评估，精选真正值得信赖的中国自主品牌。所有收录品牌均经过严格审核，确保信息真实可靠。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '品牌如何申请入驻国产第一页？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '品牌方可通过"关于我们"页面的联系方式提交入驻申请。我们将在收到申请后的5个工作日内进行审核评估，审核通过后将为品牌创建专属展示页面。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '国产第一页的品牌信息多久更新一次？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '我们的编辑团队会定期对平台收录的品牌信息进行更新维护。同时，已入驻品牌方也可随时联系我们来更新品牌信息，确保用户获取到最新、最准确的品牌资讯。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '如何在国产第一页找到适合我的国货品牌？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '您可以通过首页的分类导航浏览不同品类的品牌，也可以参考我们精选的推荐榜单和深度文章。每个品牌页面都包含详细的产品信息和用户评价，帮助您做出最佳选择。',
                  },
                },
              ],
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}